import { useState, useEffect } from 'react';
import NavBar from '../../components/NavBar';
import NavPanel from '../../components/NavPanel';
import NavButton from '../../components/NavButton';
import ScrollUpButton from '../../components/ScrollUpButton';
import useMediaQuery from '../../hooks/useMediaQuery';
import useScrollDown from '../../hooks/useScrollDown';
import useBodyOverflow from '../../hooks/useBodyOverflow';

const Navigation = () => {
  const [panelOpen, setPanelOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isScrollDown = useScrollDown(70);
  useBodyOverflow(panelOpen); //disable/enable body page scroll

  const handleTogglePanel = () => {
    setPanelOpen(!panelOpen);
  };

  const handleClosePanel = () => {
    setPanelOpen(false);
  };

  //closes panel when screen is not mobile
  useEffect(() => {
    if (panelOpen && !isMobile) {
      setPanelOpen(false);
    }
  }, [panelOpen, isMobile]);

  return (
    <>
      <NavBar isScrollDown={isScrollDown} />
      <NavButton
        isPanelOpen={panelOpen}
        togglePanel={handleTogglePanel}
        isScrollDown={isScrollDown}
      />
      <NavPanel isOpen={panelOpen} closePanel={handleClosePanel} />
      <ScrollUpButton isScrollDown={isScrollDown} />
    </>
  );
};

export default Navigation;
